var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useEffect, useState, useContext, useMemo, useRef } from "react";
import { useStore } from "react-redux";
import { castVoteErrorMessage } from "../services/CastVoteErrors";
import { EReceiveBallotStatus, useReceiveBallot } from "../hooks/useReceiveBallot";
import { signReceivedCast, useCastReceivedBallot, } from "../hooks/useCastReceivedBallot";
import { selectReceivedBallot } from "../store/receivedBallots/receivedBallotsSlice";
import { Link as RouterLink, useNavigate, useParams, redirect, useLocation, useSubmit, } from "react-router-dom";
import { selectBallotStyleByElectionId } from "../store/ballotStyles/ballotStylesSlice";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { Box, CircularProgress } from "@mui/material";
import { useBallotStyleSlates } from "../hooks/useBallotStyleSlates";
import { BallotSlatesProvider, Dialog, EWarnBoxAnnouncement, Icon, ReviewActions, ReviewLayout, WarnBox, } from "@sequentech/ui-essentials";
import { stringToHtml, escapeTranslationValues, EVotingPortalAuditButtonCfg, ECastVoteGoldLevelPolicy, EElectionEventContestEncryptionPolicy, areAllContestsAcclaimed, } from "@sequentech/ui-core";
import { styled } from "@mui/material/styles";
import { faAngleLeft, faFire } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import { clearAuditableBallot, EBallotAuditStatus, selectAuditableBallot, selectBallotAuditStatus, } from "../store/auditableBallots/auditableBallotsSlice";
import { useMutation, useQuery } from "@apollo/client/react";
import { INSERT_CAST_VOTE } from "../queries/InsertCastVote";
import { GET_ELECTIONS } from "../queries/GetElections";
import { provideBallotService } from "../services/BallotService";
import { orderContestsForReview } from "../services/ContestsOrder";
import { addCastVotes } from "../store/castVotes/castVotesSlice";
import { useRootBackLink } from "../hooks/root-back-link";
import { CastBallotsErrorType, VotingPortalErrorType, } from "../services/VotingPortalError";
import Stepper from "../components/Stepper";
import { selectBallotSelectionByElectionId } from "../store/ballotSelections/ballotSelectionsSlice";
import { hashBallot, hashMultiBallot, } from "@sequentech/ui-core";
import { SettingsContext } from "../providers/SettingsContextProvider";
import { AuthContext } from "../providers/AuthContextProvider";
import { clearSessionStorageBallotData, BALLOT_DATA_KEY, BALLOT_DATA_EXPIRATION_KEY, snapshotSessionBallotData, isCurrentSessionBallotData, readSessionBallotLocator, } from "../store/castVotes/sessionBallotData";
import { setConfirmationScreenData } from "../store/castVotes/confirmationScreenDataSlice";
import { selectElectionById } from "../store/elections/electionsSlice";
import { completeAcclaimedElection, isDeclineToVoteByElectionId } from "../store/extra/extraSlice";
import { isSameBallotSelection } from "../services/BallotSelectionComparison";
import { getBallotReviewSummary } from "../services/ReviewSummary";
import { ReviewContestFooter } from "../components/ReviewSummary/ReviewContestFooter";
import { ReviewSelectionSummary } from "../components/ReviewSummary/ReviewSelectionSummary";
import UnfilledContestsDialog from "../components/UnfilledContestsDialog/UnfilledContestsDialog";
import { getUnfilledContests } from "../services/UnfilledContests";
var StyledButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    padding: 5px;\n\n    span {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        padding: 5px;\n    }\n"], ["\n    display: flex;\n    padding: 5px;\n\n    span {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        padding: 5px;\n    }\n"])));
var BallotIdHelpDialog = styled(Dialog)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    @media (min-width: 601px) {\n        .MuiDialogActions-root.has-middle > .cancel-button,\n        .MuiDialogActions-root.has-middle > .audit-button {\n            flex: 1 1 0;\n            min-width: 0;\n            width: auto;\n        }\n    }\n"], ["\n    @media (min-width: 601px) {\n        .MuiDialogActions-root.has-middle > .cancel-button,\n        .MuiDialogActions-root.has-middle > .audit-button {\n            flex: 1 1 0;\n            min-width: 0;\n            width: auto;\n        }\n    }\n"])));
var AuditButton = function (_a) {
    var onClick = _a.onClick;
    var t = useTranslation().t;
    return (_jsxs(StyledButton, { className: "audit-button", sx: { width: { xs: "100%", sm: "200px" } }, variant: "warning", onClick: onClick, children: [_jsx(Icon, { className: "audit-button-icon", icon: faFire, size: "sm" }), _jsx(Box, { className: "audit-button-label", children: t("reviewScreen.auditButton") })] }));
};
var AuditBallotHelpDialog = function (_a) {
    var auditBallotHelp = _a.auditBallotHelp, handleClose = _a.handleClose;
    var t = useTranslation().t;
    return (_jsx(Dialog, { className: "audit-ballot-dialog", handleClose: handleClose, open: auditBallotHelp, title: t("reviewScreen.auditBallotHelpDialog.title"), ok: t("reviewScreen.auditBallotHelpDialog.ok"), cancel: t("reviewScreen.auditBallotHelpDialog.cancel"), variant: "warning", maxWidth: "md", children: stringToHtml(t("reviewScreen.auditBallotHelpDialog.content")) }));
};
/*
 * `LoadingOrCastButton` was here, and the whole row with it.
 *
 * Both are `ReviewActions` in `ui-essentials` now — the spinner, the chevron, the flame on
 * *Audit ballot* and its warning colour — so the Election Architect's preview shows this
 * row instead of three plain buttons of its own. `AuditButton` above stays: the
 * ballot-identifier help dialog puts one inside itself when the audit policy says
 * `SHOW_IN_HELP`, which is not part of the row.
 */
var useAddFakeCastVote = function (tenantId, eventId) {
    var dispatch = useAppDispatch();
    return function () {
        var newCastVote = {
            id: eventId !== null && eventId !== void 0 ? eventId : "",
            tenant_id: tenantId !== null && tenantId !== void 0 ? tenantId : "",
            election_id: eventId,
            area_id: eventId,
            created_at: null,
            last_updated_at: null,
            annotations: null,
            labels: null,
            content: "",
            cast_ballot_signature: "",
            voter_id_string: null,
            election_event_id: eventId !== null && eventId !== void 0 ? eventId : "",
        };
        console.log("faking casting demo vote");
        dispatch(addCastVotes([newCastVote]));
    };
};
var useTryInsertCastVote = function () {
    var t = useTranslation().t;
    var insertCastVote = useMutation(INSERT_CAST_VOTE)[0];
    var dispatch = useAppDispatch();
    var store = useStore();
    return function (electionId_1, ballotId_1, content_1, reportError_1) {
        var args_1 = [];
        for (var _i = 4; _i < arguments.length; _i++) {
            args_1[_i - 4] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([electionId_1, ballotId_1, content_1, reportError_1], args_1, true), void 0, function (electionId, ballotId, content, reportError, isCurrent) {
            var setErrorMsg, result, newCastVote, currentBallot, error_1;
            var _a, _b, _c;
            if (isCurrent === void 0) { isCurrent = function () { return true; }; }
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        setErrorMsg = function (message) {
                            if (isCurrent())
                                reportError(message);
                        };
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, insertCastVote({
                                variables: {
                                    electionId: electionId,
                                    ballotId: ballotId,
                                    content: content,
                                },
                            })];
                    case 2:
                        result = _d.sent();
                        if (result.error) {
                            console.log((_a = result.error) === null || _a === void 0 ? void 0 : _a.message);
                            setErrorMsg(t("reviewScreen.error.".concat(CastBallotsErrorType.UNABLE_TO_FETCH_DATA)));
                            return [2 /*return*/, false];
                        }
                        if (!isCurrent())
                            return [2 /*return*/, false];
                        newCastVote = (_b = result.data) === null || _b === void 0 ? void 0 : _b.insert_cast_vote;
                        if (newCastVote) {
                            dispatch(addCastVotes([newCastVote]));
                            dispatch(setConfirmationScreenData({
                                electionId: electionId,
                                confirmationScreenData: { ballotId: ballotId, isDemo: false },
                            }));
                            currentBallot = (_c = store.getState().auditableBallots[electionId]) === null || _c === void 0 ? void 0 : _c.auditableBallot;
                            if (!currentBallot || currentBallot.ballot_hash === ballotId) {
                                dispatch(clearAuditableBallot(electionId));
                                provideBallotService().forgetVoterSigningKey(electionId);
                            }
                        }
                        return [2 /*return*/, !!newCastVote];
                    case 3:
                        error_1 = _d.sent();
                        console.log(error_1);
                        setErrorMsg(castVoteErrorMessage(error_1, t));
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
};
// The ref rejects a second cast before the next render; the state renders the
// pending cast.
var useCastingState = function () {
    var castingRef = useRef(false);
    var _a = useState(false), isCasting = _a[0], setIsCasting = _a[1];
    var setCasting = function (value) {
        castingRef.current = value;
        setIsCasting(value);
    };
    return { castingRef: castingRef, isCasting: isCasting, setCasting: setCasting };
};
var ActionButtons = function (_a) {
    var _b, _c;
    var ballotStyle = _a.ballotStyle, auditableBallot = _a.auditableBallot, auditButtonCfg = _a.auditButtonCfg, castVoteConfirmModal = _a.castVoteConfirmModal, ballotId = _a.ballotId, setErrorMsg = _a.setErrorMsg, isGoldenPolicy = _a.isGoldenPolicy, isMultiContest = _a.isMultiContest, isDeclineToVote = _a.isDeclineToVote, isBlankBallot = _a.isBlankBallot, isFullyAcclaimed = _a.isFullyAcclaimed, hasInconsistentHash = _a.hasInconsistentHash, isAwaitingReceipt = _a.isAwaitingReceipt, receivedBallotId = _a.receivedBallotId, unfilledContests = _a.unfilledContests;
    var castRefused = hasInconsistentHash || isAwaitingReceipt;
    var t = useTranslation().t;
    var navigate = useNavigate();
    var location = useLocation();
    var _d = useState(false), auditBallotHelp = _d[0], setAuditBallotHelp = _d[1];
    var _e = useCastingState(), castingRef = _e.castingRef, isCasting = _e.isCasting, setCasting = _e.setCasting;
    var _f = React.useState(false), isConfirmCastVoteModal = _f[0], setConfirmCastVoteModal = _f[1];
    var _g = useState(false), isUnfilledContestsModal = _g[0], setUnfilledContestsModal = _g[1];
    var _h = useParams(), tenantId = _h.tenantId, eventId = _h.eventId;
    var _j = provideBallotService(), toHashableBallot = _j.toHashableBallot, toHashableMultiBallot = _j.toHashableMultiBallot;
    var submit = useSubmit();
    var isDemo = !!((_c = (_b = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml) === null || _b === void 0 ? void 0 : _b.public_key) === null || _c === void 0 ? void 0 : _c.is_demo);
    var globalSettings = useContext(SettingsContext).globalSettings;
    var authContext = useContext(AuthContext);
    var isGoldUser = authContext.isGoldUser, reauthWithGold = authContext.reauthWithGold;
    var addFakeCastVote = useAddFakeCastVote(tenantId, eventId);
    var tryInsertCastVote = useTryInsertCastVote();
    var tryCastReceivedBallot = useCastReceivedBallot();
    var storedReceivedBallot = useAppSelector(selectReceivedBallot(ballotStyle.election_id));
    var receivedBallot = receivedBallotId && (storedReceivedBallot === null || storedReceivedBallot === void 0 ? void 0 : storedReceivedBallot.ballot_id) === receivedBallotId
        ? storedReceivedBallot
        : undefined;
    var dispatch = useAppDispatch();
    var handleClose = function (value) {
        setAuditBallotHelp(false);
        if (value) {
            navigate("/tenant/".concat(tenantId, "/event/").concat(eventId, "/election/").concat(ballotStyle.election_id, "/audit").concat(location.search));
        }
    };
    var handleCloseCastVoteDialog = function (value) {
        setConfirmCastVoteModal(false);
        if (value) {
            castBallotAction();
        }
    };
    var handleCloseUnfilledContestsDialog = function (value) {
        setUnfilledContestsModal(false);
        if (value) {
            castBallotAction();
        }
    };
    // Asked again on every cast: the answer is not kept, so a voter who goes
    // back to edit and returns with unfilled positions confirms them anew.
    var onCast = function () {
        if (unfilledContests.length > 0) {
            setUnfilledContestsModal(true);
        }
        else if (castVoteConfirmModal && !isFullyAcclaimed) {
            setConfirmCastVoteModal(true);
        }
        else {
            castBallotAction();
        }
    };
    var storeBallotDataAndReauth = function (ballotData) { return __awaiter(void 0, void 0, void 0, function () {
        var errorType, FIVE_MINUTES, owner, previous, reuse, saved, baseUrl, error_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    errorType = VotingPortalErrorType.UNABLE_TO_CAST_BALLOT;
                    try {
                        FIVE_MINUTES = 5 * 60 * 1000;
                        owner = {
                            tenantId: tenantId !== null && tenantId !== void 0 ? tenantId : "",
                            eventId: eventId !== null && eventId !== void 0 ? eventId : "",
                            userId: authContext.userId,
                        };
                        previous = snapshotSessionBallotData();
                        reuse = false;
                        try {
                            saved = JSON.parse((_a = previous.serialized) !== null && _a !== void 0 ? _a : "null");
                            reuse =
                                !!saved &&
                                    saved.ballotId === ballotData.ballotId &&
                                    saved.electionId === ballotData.electionId &&
                                    saved.ballot === ballotData.ballot &&
                                    JSON.stringify(saved.owner) === JSON.stringify(owner) &&
                                    Number(previous.expiry) > Date.now() &&
                                    Number(previous.expiry) <= Date.now() + FIVE_MINUTES;
                        }
                        catch (_c) {
                            /* A malformed request cannot be retried. */
                        }
                        if (!reuse) {
                            sessionStorage.setItem(BALLOT_DATA_KEY, JSON.stringify(__assign(__assign({}, ballotData), { owner: owner })));
                            sessionStorage.setItem(BALLOT_DATA_EXPIRATION_KEY, (Date.now() + FIVE_MINUTES).toString());
                        }
                    }
                    catch (e) {
                        console.error("Error saving ballotData to sessionStorage", e);
                        clearSessionStorageBallotData();
                        setErrorMsg(t("reviewScreen.error.".concat(CastBallotsErrorType.SESSION_STORAGE_ERROR)));
                        return [2 /*return*/, submit({ error: errorType }, { method: "post" })];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    baseUrl = new URL(window.location.href);
                    return [4 /*yield*/, reauthWithGold(baseUrl.toString())];
                case 2:
                    _b.sent();
                    setCasting(false);
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _b.sent();
                    console.error("Re-authentication failed");
                    setCasting(false);
                    setErrorMsg(t("reviewScreen.error.".concat(CastBallotsErrorType.REAUTH_FAILED)));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var backNavigateTo = isDeclineToVote
        ? "/tenant/".concat(tenantId, "/event/").concat(eventId, "/election/").concat(ballotStyle.election_id, "/start").concat(location.search)
        : "/tenant/".concat(tenantId, "/event/").concat(eventId, "/election/").concat(ballotStyle.election_id, "/vote").concat(location.search);
    var castBallotAction = function () { return __awaiter(void 0, void 0, void 0, function () {
        var errorType, saved, pending, owner, _a, ballotData, hashableBallot, ballotError, receivedCast, ballotBoxKey, ballotData, cast, _b;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (castingRef.current || castRefused) {
                        return [2 /*return*/];
                    }
                    // A fully acclaimed election produces no ballot, so there is nothing
                    // to encrypt, hash or cast: the voter goes straight to confirmation.
                    if (isFullyAcclaimed) {
                        setCasting(true);
                        dispatch(completeAcclaimedElection(ballotStyle.election_id));
                        return [2 /*return*/, submit(null, { method: "post" })];
                    }
                    errorType = VotingPortalErrorType.UNABLE_TO_CAST_BALLOT;
                    setCasting(true);
                    if (!isGoldenPolicy) return [3 /*break*/, 5];
                    saved = snapshotSessionBallotData();
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 4, , 5]);
                    pending = JSON.parse((_c = saved.serialized) !== null && _c !== void 0 ? _c : "null");
                    owner = {
                        tenantId: tenantId !== null && tenantId !== void 0 ? tenantId : "",
                        eventId: eventId !== null && eventId !== void 0 ? eventId : "",
                        userId: authContext.userId,
                    };
                    if (!((pending === null || pending === void 0 ? void 0 : pending.ballotId) === ballotId &&
                        pending.electionId === ballotStyle.election_id &&
                        pending.isDemo === isDemo &&
                        JSON.stringify(pending.owner) === JSON.stringify(owner) &&
                        Number(saved.expiry) > Date.now() &&
                        Number(saved.expiry) <= Date.now() + 300000)) return [3 /*break*/, 3];
                    return [4 /*yield*/, storeBallotDataAndReauth(pending)];
                case 2: return [2 /*return*/, _d.sent()];
                case 3: return [3 /*break*/, 5];
                case 4:
                    _a = _d.sent();
                    return [3 /*break*/, 5];
                case 5:
                    if (!(isDemo || globalSettings.DISABLE_AUTH)) return [3 /*break*/, 8];
                    if (!isGoldenPolicy) return [3 /*break*/, 7];
                    ballotData = {
                        ballotId: ballotId,
                        auditButtonCfg: auditButtonCfg,
                        electionId: ballotStyle.election_id,
                        isDemo: true,
                        ballot: JSON.stringify("{}"),
                        timestamp: Date.now(), // Add timestamp for expiration check
                    };
                    return [4 /*yield*/, storeBallotDataAndReauth(ballotData)];
                case 6: return [2 /*return*/, _d.sent()];
                case 7:
                    addFakeCastVote();
                    dispatch(setConfirmationScreenData({
                        electionId: ballotStyle.election_id,
                        confirmationScreenData: { ballotId: ballotId, isDemo: true, auditButtonCfg: auditButtonCfg },
                    }));
                    dispatch(clearAuditableBallot(ballotStyle.election_id));
                    provideBallotService().forgetVoterSigningKey(ballotStyle.election_id);
                    return [2 /*return*/, submit(null, { method: "post" })];
                case 8:
                    try {
                        hashableBallot = isMultiContest
                            ? toHashableMultiBallot(auditableBallot)
                            : toHashableBallot(auditableBallot);
                    }
                    catch (error) {
                        setCasting(false);
                        console.error(error);
                        ballotError = error || undefined;
                        if (ballotError === null || ballotError === void 0 ? void 0 : ballotError.error_type) {
                            setErrorMsg(t("reviewScreen.error.".concat(ballotError.error_type)));
                        }
                        else {
                            setErrorMsg(t("reviewScreen.error.".concat(CastBallotsErrorType.TO_HASHABLE_BALLOT_ERROR)));
                        }
                        return [2 /*return*/, submit({ error: errorType }, { method: "post" })];
                    }
                    ballotBoxKey = ballotStyle.ballot_eml.ballot_box_key;
                    if (receivedBallot && ballotBoxKey) {
                        try {
                            receivedCast = signReceivedCast(receivedBallot, ballotBoxKey);
                        }
                        catch (error) {
                            console.error("The key that signed the ballot is gone:", error);
                            setCasting(false);
                            return [2 /*return*/, navigate(backNavigateTo)];
                        }
                    }
                    if (!isGoldenPolicy) return [3 /*break*/, 10];
                    ballotData = {
                        ballotId: ballotId,
                        receivedCast: receivedCast,
                        auditButtonCfg: auditButtonCfg,
                        electionId: ballotStyle.election_id,
                        isDemo: isDemo,
                        ballot: JSON.stringify(hashableBallot),
                        timestamp: Date.now(), // Add timestamp for expiration check
                    };
                    return [4 /*yield*/, storeBallotDataAndReauth(ballotData)];
                case 9: return [2 /*return*/, _d.sent()];
                case 10:
                    if (!receivedCast) return [3 /*break*/, 12];
                    return [4 /*yield*/, tryCastReceivedBallot(receivedCast, setErrorMsg)];
                case 11:
                    _b = _d.sent();
                    return [3 /*break*/, 14];
                case 12: return [4 /*yield*/, tryInsertCastVote(ballotStyle.election_id, ballotId, JSON.stringify(hashableBallot), setErrorMsg)];
                case 13:
                    _b = _d.sent();
                    _d.label = 14;
                case 14:
                    cast = _b;
                    if (!cast) {
                        setCasting(false);
                        return [2 /*return*/, submit({ error: errorType }, { method: "post" })];
                    }
                    return [2 /*return*/, submit(null, { method: "post" })];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [auditButtonCfg === EVotingPortalAuditButtonCfg.SHOW ? (_jsx(AuditBallotHelpDialog, { auditBallotHelp: auditBallotHelp, handleClose: handleClose })) : null, _jsx(ReviewActions, { withAudit: auditButtonCfg === EVotingPortalAuditButtonCfg.SHOW && !isFullyAcclaimed, casting: isCasting, isFullyAcclaimed: isFullyAcclaimed, backComponent: RouterLink, backTo: backNavigateTo, onAudit: function () { return setAuditBallotHelp(true); }, 
                // A detected hash mismatch refuses the cast, and so does a ballot
                // the ballot box has not received; leaving the handler out is
                // what disables the button.
                onCast: castRefused ? undefined : onCast }), _jsx(UnfilledContestsDialog, { open: isUnfilledContestsModal, unfilledContests: unfilledContests, handleClose: handleCloseUnfilledContestsDialog }), _jsx(Dialog, { className: "confirm-cast-ballot-dialog", handleClose: handleCloseCastVoteDialog, open: isConfirmCastVoteModal, title: t(isBlankBallot
                    ? "reviewScreen.confirmCastBlankBallotDialog.title"
                    : "reviewScreen.confirmCastVoteDialog.title"), ok: t(isBlankBallot
                    ? "reviewScreen.confirmCastBlankBallotDialog.ok"
                    : "reviewScreen.confirmCastVoteDialog.ok"), cancel: t(isBlankBallot
                    ? "reviewScreen.confirmCastBlankBallotDialog.cancel"
                    : "reviewScreen.confirmCastVoteDialog.cancel"), variant: "info", children: stringToHtml(t(isBlankBallot
                    ? "reviewScreen.confirmCastBlankBallotDialog.content"
                    : "reviewScreen.confirmCastVoteDialog.content")) })] }));
};
var ECastRecovery;
(function (ECastRecovery) {
    ECastRecovery["READY"] = "ready";
    ECastRecovery["CASTING"] = "casting";
    ECastRecovery["RETRY"] = "retry";
    ECastRecovery["EXPIRED"] = "expired";
})(ECastRecovery || (ECastRecovery = {}));
export var ReviewScreen = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
    var electionId = useParams().electionId;
    var ballotStyle = useAppSelector(selectBallotStyleByElectionId(String(electionId)));
    // When every contest is acclaimed there is no ballot at all: no
    // encryption, no cast vote and no ballot id to show or audit.
    var isFullyAcclaimed = areAllContestsAcclaimed(ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml.contests);
    var location = useLocation();
    var auditableBallot = useAppSelector(selectAuditableBallot(String(electionId)));
    var auditStatus = useAppSelector(selectBallotAuditStatus(String(electionId)));
    var _z = useState(false), auditBallotHelp = _z[0], setAuditBallotHelp = _z[1];
    var _0 = useState(false), openBallotIdHelp = _0[0], setOpenBallotIdHelp = _0[1];
    var _1 = useState(false), openReviewScreenHelp = _1[0], setReviewScreenHelp = _1[1];
    var _2 = provideBallotService(), interpretContestSelection = _2.interpretContestSelection, interpretMultiContestSelection = _2.interpretMultiContestSelection, decodeAuditableBallot = _2.decodeAuditableBallot, decodeAuditableMultiBallot = _2.decodeAuditableMultiBallot;
    var t = useTranslation().t;
    var backLink = useRootBackLink();
    var navigate = useNavigate();
    var submit = useSubmit();
    var _3 = useParams(), tenantId = _3.tenantId, eventId = _3.eventId;
    useEffect(function () {
        if (auditStatus === EBallotAuditStatus.AUDITED)
            navigate("/tenant/".concat(tenantId, "/event/").concat(eventId, "/election/").concat(electionId, "/vote").concat(location.search));
    }, [auditStatus, tenantId, eventId, electionId, navigate, location.search]);
    var _4 = useState(), errorMsg = _4[0], setErrorMsg = _4[1];
    var authContext = useContext(AuthContext);
    var _5 = useState(ECastRecovery.READY), recovery = _5[0], setRecovery = _5[1];
    var recoveryAttempt = useRef(0);
    var recoveryMounted = useRef(true);
    var recoveryOwner = JSON.stringify([tenantId, eventId, electionId, authContext.userId]);
    var currentRecoveryOwner = useRef(recoveryOwner);
    currentRecoveryOwner.current = recoveryOwner;
    useEffect(function () {
        recoveryMounted.current = true;
        return function () {
            recoveryMounted.current = false;
            recoveryAttempt.current += 1;
        };
    }, []);
    var isGoldUser = authContext.isGoldUser, reauthWithGold = authContext.reauthWithGold;
    var _6 = useCastingState(), castingRef = _6.castingRef, isCasting = _6.isCasting, setCasting = _6.setCasting;
    var globalSettings = useContext(SettingsContext).globalSettings;
    useEffect(function () {
        recoveryAttempt.current += 1;
        setCasting(false);
        setRecovery(ECastRecovery.READY);
        setErrorMsg(undefined);
    }, [recoveryOwner]);
    var slates = useBallotStyleSlates(ballotStyle);
    var dispatch = useAppDispatch();
    var addFakeCastVote = useAddFakeCastVote(tenantId, eventId);
    var tryInsertCastVote = useTryInsertCastVote();
    var tryCastReceivedBallot = useCastReceivedBallot();
    var electionFromRedux = useAppSelector(selectElectionById(String(electionId)));
    var isDeclineToVote = useAppSelector(isDeclineToVoteByElectionId(String(electionId)));
    var _7 = useQuery(GET_ELECTIONS, {
        variables: {
            electionIds: electionId ? [electionId] : [],
        },
        skip: globalSettings.DISABLE_AUTH || electionFromRedux !== undefined, // Skip query if we can get the election from redux (golden user cant)
    }), dataElections = _7.data, errorElections = _7.error;
    useEffect(function () {
        if (!errorElections)
            return;
        var isNetworkError = errorElections.name === "NetworkError" ||
            errorElections.message.includes("fetch") ||
            errorElections.message.includes("network");
        if (isNetworkError) {
            setErrorMsg(t("reviewScreen.error.".concat(CastBallotsErrorType.NETWORK_ERROR)));
        }
        else {
            setErrorMsg(t("reviewScreen.error.".concat(CastBallotsErrorType.UNABLE_TO_FETCH_DATA)));
        }
    }, [errorElections, t]);
    var isGoldenPolicy = useMemo(function () {
        var _a, _b;
        return electionFromRedux !== undefined
            ? ((_a = electionFromRedux === null || electionFromRedux === void 0 ? void 0 : electionFromRedux.presentation) === null || _a === void 0 ? void 0 : _a.cast_vote_gold_level) ===
                ECastVoteGoldLevelPolicy.GOLD_LEVEL
            : (_b = dataElections === null || dataElections === void 0 ? void 0 : dataElections.sequent_backend_election) === null || _b === void 0 ? void 0 : _b.some(function (item) {
                var _a;
                return (item === null || item === void 0 ? void 0 : item.id) === electionId &&
                    ((_a = item === null || item === void 0 ? void 0 : item.presentation) === null || _a === void 0 ? void 0 : _a.cast_vote_gold_level) ===
                        ECastVoteGoldLevelPolicy.GOLD_LEVEL;
            });
    }, [electionFromRedux, dataElections]);
    console.log(electionFromRedux !== undefined);
    var auditButtonCfg = (_c = (_b = (_a = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml) === null || _a === void 0 ? void 0 : _a.election_presentation) === null || _b === void 0 ? void 0 : _b.audit_button_cfg) !== null && _c !== void 0 ? _c : EVotingPortalAuditButtonCfg.SHOW;
    var castVoteConfirmModal = (_f = (_e = (_d = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml) === null || _d === void 0 ? void 0 : _d.election_presentation) === null || _e === void 0 ? void 0 : _e.cast_vote_confirm) !== null && _f !== void 0 ? _f : false;
    var isMultiContest = ((_g = auditableBallot === null || auditableBallot === void 0 ? void 0 : auditableBallot.config.election_event_presentation) === null || _g === void 0 ? void 0 : _g.contest_encryption_policy) ==
        EElectionEventContestEncryptionPolicy.MULTIPLE_CONTESTS;
    var hashableBallot = auditableBallot
        ? isMultiContest
            ? hashMultiBallot(auditableBallot)
            : hashBallot(auditableBallot)
        : undefined;
    var ballotId = useMemo(function () {
        return auditableBallot && hashableBallot ? hashableBallot : undefined;
    }, [auditableBallot, hashableBallot]);
    var selectionState = useAppSelector(selectBallotSelectionByElectionId((_h = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.election_id) !== null && _h !== void 0 ? _h : ""));
    var isBlankBallot = Boolean((selectionState === null || selectionState === void 0 ? void 0 : selectionState.length) && selectionState.every(function (contest) { return contest.is_blank_ballot; }));
    // The review shows the selections in the store and casts the encrypted
    // ballot. They differ when the selections changed after encrypting, for
    // example through the browser history.
    var hasStaleBallot = useMemo(function () {
        if (!auditableBallot || !selectionState) {
            return false;
        }
        try {
            var encryptedSelection = isMultiContest
                ? decodeAuditableMultiBallot(auditableBallot)
                : decodeAuditableBallot(auditableBallot);
            return (!!encryptedSelection && !isSameBallotSelection(encryptedSelection, selectionState));
        }
        catch (error) {
            console.log("Error decoding the ballot under review: ".concat(error));
            return false;
        }
    }, [auditableBallot, selectionState, isMultiContest]);
    var votePath = "/tenant/".concat(tenantId, "/event/").concat(eventId, "/election/").concat(electionId, "/vote").concat(location.search);
    useEffect(function () {
        if (hasStaleBallot) {
            navigate(votePath, { replace: true });
        }
    }, [hasStaleBallot, navigate, votePath]);
    var errorSelectionState = useMemo(function () {
        if (!selectionState || !ballotStyle || isFullyAcclaimed || hasStaleBallot) {
            return [];
        }
        return isMultiContest
            ? interpretMultiContestSelection(selectionState, ballotStyle.ballot_eml)
            : interpretContestSelection(selectionState, ballotStyle.ballot_eml);
    }, [selectionState, isMultiContest, ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml, hasStaleBallot]);
    var reviewSummary = useMemo(function () {
        var _a;
        return ballotStyle && ((_a = slates.resolved) === null || _a === void 0 ? void 0 : _a.slates.length) && !isDeclineToVote && !isFullyAcclaimed
            ? getBallotReviewSummary(ballotStyle.ballot_eml.contests, slates.resolved, selectionState)
            : undefined;
    }, [ballotStyle, slates.resolved, selectionState, isDeclineToVote, isFullyAcclaimed]);
    var hasInconsistentHash = Boolean(ballotId && (auditableBallot === null || auditableBallot === void 0 ? void 0 : auditableBallot.ballot_hash) && ballotId !== auditableBallot.ballot_hash);
    var hashErrorMsg = hasInconsistentHash
        ? t("reviewScreen.error.".concat(CastBallotsErrorType.INCONSISTENT_HASH), escapeTranslationValues({
            ballotId: ballotId,
            auditableBallotHash: (_j = auditableBallot === null || auditableBallot === void 0 ? void 0 : auditableBallot.ballot_hash) !== null && _j !== void 0 ? _j : "",
        }))
        : undefined;
    var receipt = useReceiveBallot({
        ballotStyle: ballotStyle,
        auditableBallot: auditableBallot,
        ballotHash: ballotId,
        isMultiContest: isMultiContest,
        skip: !!((_l = (_k = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml) === null || _k === void 0 ? void 0 : _k.public_key) === null || _l === void 0 ? void 0 : _l.is_demo) ||
            globalSettings.DISABLE_AUTH ||
            isFullyAcclaimed ||
            hasInconsistentHash,
    });
    var isReceiptRequired = receipt.status !== EReceiveBallotStatus.NOT_REQUIRED;
    var isAwaitingReceipt = isReceiptRequired && receipt.status !== EReceiveBallotStatus.RECEIVED;
    // With receipts on, the Ballot ID is the ballot box's: there is none to
    // show until the ballot box has stored and signed the ballot.
    var shownBallotId = isReceiptRequired ? receipt.ballotId : ballotId || "";
    var displayedErrorMsg = (_m = hashErrorMsg !== null && hashErrorMsg !== void 0 ? hashErrorMsg : receipt.errorMsg) !== null && _m !== void 0 ? _m : errorMsg;
    var handleCloseDialogAuditHelp = function (value) {
        setAuditBallotHelp(false);
        if (value) {
            navigate("/tenant/".concat(tenantId, "/event/").concat(eventId, "/election/").concat(ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.election_id, "/audit").concat(location.search));
        }
    };
    // Dismiss only. Auditing is reached from AuditButton, which confirms through
    // AuditBallotHelpDialog first; this dialog used to navigate there too, which
    // is the duplicate audit trigger reported in META-12776. Matches how
    // AuditScreen renders the same dialog.
    function handleCloseDialogIdHelp() {
        setOpenBallotIdHelp(false);
    }
    var getBallotDataFromSessionStorage = function (snapshot) {
        var _a, _b;
        var owner = { tenantId: tenantId !== null && tenantId !== void 0 ? tenantId : "", eventId: eventId !== null && eventId !== void 0 ? eventId : "", userId: authContext.userId };
        var fail = function (error, expired, locator) {
            if (expired === void 0) { expired = false; }
            clearSessionStorageBallotData(snapshot, locator);
            setErrorMsg(t("reviewScreen.error.".concat(error)));
            setRecovery(expired ? ECastRecovery.EXPIRED : ECastRecovery.RETRY);
            return undefined;
        };
        if (!snapshot.serialized && !snapshot.expiry) {
            var locator = readSessionBallotLocator(owner, electionId !== null && electionId !== void 0 ? electionId : "");
            if (locator)
                return fail(CastBallotsErrorType.SESSION_EXPIRED, true, locator);
        }
        if (!snapshot.serialized || !snapshot.expiry)
            return fail(CastBallotsErrorType.SESSION_STORAGE_ERROR);
        var expiresAt = Number(snapshot.expiry);
        if (!Number.isFinite(expiresAt) || expiresAt > Date.now() + 5 * 60 * 1000)
            return fail(CastBallotsErrorType.NOT_VALID_BALLOT_DATA_ERROR);
        try {
            var data = JSON.parse(snapshot.serialized);
            if (!data ||
                typeof data.ballotId !== "string" ||
                !data.ballotId ||
                data.electionId !== electionId ||
                typeof data.ballot !== "string" ||
                !data.ballot)
                return fail(CastBallotsErrorType.NOT_VALID_BALLOT_DATA_ERROR);
            if (!data.owner ||
                data.owner.tenantId !== tenantId ||
                data.owner.eventId !== eventId ||
                data.owner.userId !== authContext.userId)
                return fail(CastBallotsErrorType.NOT_VALID_BALLOT_DATA_ERROR);
            var receipt_1 = (_a = data.receivedCast) === null || _a === void 0 ? void 0 : _a.receivedBallot;
            if (data.receivedCast &&
                (!receipt_1 ||
                    receipt_1.tenant_id !== tenantId ||
                    receipt_1.election_event_id !== eventId ||
                    receipt_1.election_id !== electionId ||
                    receipt_1.ballot_hash !== data.ballotId ||
                    !data.receivedCast.castSignature ||
                    !/^[0-9A-HJKMNP-TV-Z]{4}-[0-9A-HJKMNP-TV-Z]{4}$/.test(receipt_1.ballot_id)))
                return fail(CastBallotsErrorType.NOT_VALID_BALLOT_DATA_ERROR);
            if (Date.now() >= expiresAt)
                return fail(CastBallotsErrorType.SESSION_EXPIRED, true, {
                    owner: owner,
                    electionId: data.electionId,
                    ballotId: (_b = receipt_1 === null || receipt_1 === void 0 ? void 0 : receipt_1.ballot_id) !== null && _b !== void 0 ? _b : data.ballotId,
                });
            return data;
        }
        catch (_c) {
            return fail(CastBallotsErrorType.PARSE_BALLOT_DATA_ERROR);
        }
    };
    var goldenUserCastBallotAction = function () { return __awaiter(void 0, void 0, void 0, function () {
        var snapshot, ballotData, attempt, owner, isCurrent, _a, setCurrentError, cast, _b, _c;
        var _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    if (castingRef.current ||
                        hasInconsistentHash ||
                        (!globalSettings.DISABLE_AUTH && !authContext.userId))
                        return [2 /*return*/];
                    snapshot = snapshotSessionBallotData();
                    ballotData = getBallotDataFromSessionStorage(snapshot);
                    if (!ballotData)
                        return [2 /*return*/];
                    attempt = ++recoveryAttempt.current;
                    owner = recoveryOwner;
                    isCurrent = function () {
                        return recoveryMounted.current &&
                            recoveryAttempt.current === attempt &&
                            currentRecoveryOwner.current === owner &&
                            isCurrentSessionBallotData(snapshot);
                    };
                    setCasting(true);
                    setRecovery(ECastRecovery.CASTING);
                    setErrorMsg(undefined);
                    if (!!isGoldUser()) return [3 /*break*/, 5];
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, reauthWithGold(window.location.href)];
                case 2:
                    _f.sent();
                    if (isCurrent()) {
                        setRecovery(ECastRecovery.RETRY);
                        setCasting(false);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    _a = _f.sent();
                    if (isCurrent()) {
                        setErrorMsg(t("reviewScreen.error.".concat(CastBallotsErrorType.REAUTH_FAILED)));
                        setRecovery(ECastRecovery.RETRY);
                        setCasting(false);
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
                case 5:
                    setCurrentError = function (message) {
                        if (isCurrent())
                            setErrorMsg(message);
                    };
                    if (!ballotData.isDemo) return [3 /*break*/, 6];
                    _b = true;
                    return [3 /*break*/, 11];
                case 6:
                    if (!ballotData.receivedCast) return [3 /*break*/, 8];
                    return [4 /*yield*/, tryCastReceivedBallot(ballotData.receivedCast, setCurrentError, isCurrent)];
                case 7:
                    _c = _f.sent();
                    return [3 /*break*/, 10];
                case 8: return [4 /*yield*/, tryInsertCastVote(ballotData.electionId, ballotData.ballotId, ballotData.ballot, setCurrentError, isCurrent)];
                case 9:
                    _c = _f.sent();
                    _f.label = 10;
                case 10:
                    _b = _c;
                    _f.label = 11;
                case 11:
                    cast = _b;
                    if (!isCurrent())
                        return [2 /*return*/];
                    if (!cast) {
                        setCasting(false);
                        setRecovery(ECastRecovery.RETRY);
                        return [2 /*return*/];
                    }
                    if (ballotData.isDemo) {
                        addFakeCastVote();
                        dispatch(clearAuditableBallot(ballotData.electionId));
                        provideBallotService().forgetVoterSigningKey(ballotData.electionId);
                    }
                    dispatch(setConfirmationScreenData({
                        electionId: ballotData.electionId,
                        confirmationScreenData: {
                            ballotId: (_e = (_d = ballotData.receivedCast) === null || _d === void 0 ? void 0 : _d.receivedBallot.ballot_id) !== null && _e !== void 0 ? _e : ballotData.ballotId,
                            isDemo: ballotData.isDemo,
                            auditButtonCfg: ballotData.auditButtonCfg,
                        },
                    }));
                    clearSessionStorageBallotData(snapshot);
                    return [2 /*return*/, submit(null, { method: "post" })];
            }
        });
    }); };
    var needsRecovery = (!ballotStyle || !auditableBallot || !selectionState) && isGoldenPolicy && !isFullyAcclaimed;
    useEffect(function () {
        if (needsRecovery && recovery === ECastRecovery.READY && !castingRef.current)
            void goldenUserCastBallotAction();
    }, [needsRecovery, recovery, recoveryOwner]);
    if (needsRecovery && !hasInconsistentHash) {
        var saved_1 = snapshotSessionBallotData();
        var canRetry = recovery === ECastRecovery.RETRY && !!saved_1.serialized && !!saved_1.expiry;
        var savedBallotId = (_p = (_o = readSessionBallotLocator({ tenantId: tenantId !== null && tenantId !== void 0 ? tenantId : "", eventId: eventId !== null && eventId !== void 0 ? eventId : "", userId: authContext.userId }, electionId !== null && electionId !== void 0 ? electionId : "")) === null || _o === void 0 ? void 0 : _o.ballotId) !== null && _p !== void 0 ? _p : "";
        try {
            var data = JSON.parse((_q = saved_1.serialized) !== null && _q !== void 0 ? _q : "null");
            if (data &&
                data.owner &&
                data.owner.tenantId === tenantId &&
                data.owner.eventId === eventId &&
                data.owner.userId === authContext.userId &&
                data.electionId === electionId)
                savedBallotId =
                    (_t = (_s = (_r = data.receivedCast) === null || _r === void 0 ? void 0 : _r.receivedBallot.ballot_id) !== null && _s !== void 0 ? _s : data.ballotId) !== null && _t !== void 0 ? _t : savedBallotId;
        }
        catch (_8) {
            /* Invalid data is already rejected by recovery. */
        }
        return (_jsx(Box, { className: "review-cast-recovery", sx: { margin: "auto 0", textAlign: "center" }, children: recovery === ECastRecovery.CASTING || recovery === ECastRecovery.READY ? (_jsx(CircularProgress, { className: "review-cast-recovery-loading", "aria-label": t("a11y.loading") })) : (_jsxs(_Fragment, { children: [_jsxs(WarnBox, { className: "review-cast-recovery-error", variant: "error", announcement: EWarnBoxAnnouncement.ASSERTIVE, children: [errorMsg && stringToHtml(errorMsg), t("reviewScreen.castRecovery.uncertain")] }), canRetry && (_jsx(StyledButton, { className: "review-cast-recovery-retry-button", onClick: function () { return void goldenUserCastBallotAction(); }, children: t("ballotPrivacy.retry") })), _jsx(StyledButton, { className: "review-cast-recovery-back-button", onClick: function () {
                            recoveryAttempt.current += 1;
                            clearSessionStorageBallotData(saved_1);
                            navigate(backLink);
                        }, children: t("reviewScreen.backButton") }), _jsx(StyledButton, { className: "review-cast-recovery-check-button", component: RouterLink, to: "/tenant/".concat(tenantId, "/event/").concat(eventId, "/election/").concat(electionId, "/ballot-locator/").concat(encodeURIComponent(savedBallotId)).concat(location.search), children: t(savedBallotId
                            ? "reviewScreen.castRecovery.checkBallot"
                            : "ballotLocator.locate") })] })) }));
    }
    if (hasStaleBallot) {
        return _jsx(CircularProgress, { className: "review-progress", "aria-label": t("a11y.loading") });
    }
    if (!ballotStyle || (!auditableBallot && !isFullyAcclaimed)) {
        return errorMsg ? (_jsxs(Box, { className: "review-error-screen", sx: { margin: "auto 0" }, children: [_jsx(WarnBox, { className: "cast-ballot-error", variant: "error", announcement: EWarnBoxAnnouncement.ASSERTIVE, children: stringToHtml(errorMsg) }), _jsx(Box, { className: "review-error-actions", sx: {
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                        marginTop: "16px",
                    }, children: _jsxs(StyledButton, { className: "back-button", component: RouterLink, to: backLink, sx: { margin: "auto 0", width: { xs: "100%", sm: "200px" } }, children: [_jsx(Icon, { className: "back-button-icon", icon: faAngleLeft, size: "sm" }), _jsx(Box, { className: "back-button-label", children: t("reviewScreen.backButton") })] }) })] })) : (_jsx(CircularProgress, { className: "review-progress", "aria-label": t("a11y.loading") }));
    }
    var contests = orderContestsForReview(ballotStyle);
    var defaultLanguageCode = (_w = (_v = (_u = ballotStyle.ballot_eml.election_presentation) === null || _u === void 0 ? void 0 : _u.language_conf) === null || _v === void 0 ? void 0 : _v.default_language_code) !== null && _w !== void 0 ? _w : (_y = (_x = ballotStyle.ballot_eml.election_event_presentation) === null || _x === void 0 ? void 0 : _x.language_conf) === null || _y === void 0 ? void 0 : _y.default_language_code;
    // A voter who declined to vote already confirmed leaving the ballot empty.
    var unfilledContests = isDeclineToVote
        ? []
        : getUnfilledContests(contests, errorSelectionState);
    return (
    // The arrangement is `ReviewLayout`, in `ui-essentials`, so that the
    // Election Architect's ballot preview shows this screen rather than a
    // copy of it that drifts. What stays here is everything that needs the
    // store, the mutation or this screen's own state: the dialogs, the
    // breadcrumb that knows whether an election list counts as a step, and
    // the actions that cast.
    _jsx(BallotSlatesProvider, { slates: slates.config, children: _jsxs(ReviewLayout, { ballotId: auditButtonCfg === EVotingPortalAuditButtonCfg.NOT_SHOW || isFullyAcclaimed
                ? undefined
                : shownBallotId, onBallotIdHelp: function () { return setOpenBallotIdHelp(true); }, steps: _jsx(Stepper, { selected: 2 }), onTitleHelp: function () { return setReviewScreenHelp(true); }, error: displayedErrorMsg ? stringToHtml(displayedErrorMsg) : undefined, 
            // The layout says `reviewScreen.*` for itself now. What it cannot know is
            // whether this event offers *Audit ballot*, which is what chooses between the
            // two descriptions — one of them mentions a button the other event lacks.
            withAudit: auditButtonCfg !== EVotingPortalAuditButtonCfg.NOT_SHOW &&
                auditButtonCfg !== EVotingPortalAuditButtonCfg.SHOW_IN_HELP, isFullyAcclaimed: isFullyAcclaimed, ballotStyle: ballotStyle, contests: contests, errorSelectionState: errorSelectionState, isDeclineToVote: isDeclineToVote, isBlankBallot: isBlankBallot, summary: reviewSummary ? (_jsx(ReviewSelectionSummary, { summary: reviewSummary, defaultLanguage: defaultLanguageCode })) : undefined, renderContestFooter: function (contest) {
                var count = reviewSummary === null || reviewSummary === void 0 ? void 0 : reviewSummary.contests[contest.id];
                return count ? (_jsx(ReviewContestFooter, { contest: contest, count: count, to: votePath })) : null;
            }, actions: isCasting ? undefined : (_jsx(ActionButtons, { ballotStyle: ballotStyle, auditableBallot: auditableBallot, auditButtonCfg: auditButtonCfg, castVoteConfirmModal: castVoteConfirmModal, ballotId: ballotId !== null && ballotId !== void 0 ? ballotId : "", setErrorMsg: setErrorMsg, hasInconsistentHash: hasInconsistentHash, isAwaitingReceipt: isAwaitingReceipt, receivedBallotId: receipt.ballotId, isGoldenPolicy: isGoldenPolicy !== null && isGoldenPolicy !== void 0 ? isGoldenPolicy : false, isMultiContest: isMultiContest, isDeclineToVote: isDeclineToVote, isBlankBallot: isBlankBallot, isFullyAcclaimed: isFullyAcclaimed, unfilledContests: unfilledContests })), children: [_jsx(BallotIdHelpDialog, { className: "review-ballot-id-help-dialog", handleClose: handleCloseDialogIdHelp, open: openBallotIdHelp, title: t("reviewScreen.ballotIdHelpDialog.title"), maxWidth: "md", middleActions: auditButtonCfg === EVotingPortalAuditButtonCfg.SHOW_IN_HELP
                        ? [
                            _jsx(AuditButton, { onClick: function () {
                                    setOpenBallotIdHelp(false);
                                    setAuditBallotHelp(true);
                                } }, "audit-button"),
                        ]
                        : [], cancel: t("reviewScreen.ballotIdHelpDialog.cancel"), variant: "info", children: stringToHtml(t("reviewScreen.ballotIdHelpDialog.content")) }), auditButtonCfg === EVotingPortalAuditButtonCfg.SHOW_IN_HELP &&
                    !isFullyAcclaimed ? (_jsx(AuditBallotHelpDialog, { auditBallotHelp: auditBallotHelp, handleClose: handleCloseDialogAuditHelp })) : null, _jsx(Dialog, { className: "screen-help-dialog review-help-dialog", handleClose: function () { return setReviewScreenHelp(false); }, open: openReviewScreenHelp, title: t(isFullyAcclaimed
                        ? "reviewScreen.acclamation.helpDialog.title"
                        : "reviewScreen.reviewScreenHelpDialog.title"), ok: t(isFullyAcclaimed
                        ? "reviewScreen.acclamation.helpDialog.ok"
                        : "reviewScreen.reviewScreenHelpDialog.ok"), variant: "info", children: stringToHtml(t(isFullyAcclaimed
                        ? "reviewScreen.acclamation.helpDialog.content"
                        : "reviewScreen.reviewScreenHelpDialog.content")) })] }) }));
};
export default ReviewScreen;
export function action(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var data, error;
        var request = _b.request;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, request.formData()];
                case 1:
                    data = _c.sent();
                    error = data.get("error");
                    if (!error) {
                        return [2 /*return*/, redirect("../confirmation")];
                    }
                    return [2 /*return*/, null];
            }
        });
    });
}
var templateObject_1, templateObject_2;
